import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function LockedIcon(props) {
	return (
		<Svg
			width={props.size}
			height={props.size}
			viewBox='0 0 12 17'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<Path
				d='M1.125 16.5C0.8125 16.5 0.546875 16.3906 0.328125 16.1719C0.109375 15.9531 0 15.6875 0 15.375V7.2375C0 6.925 0.109375 6.65937 0.328125 6.44062C0.546875 6.22187 0.8125 6.1125 1.125 6.1125H2.4375V4.3125C2.4375 3.325 2.78438 2.48438 3.47813 1.79063C4.17188 1.09688 5.0125 0.75 6 0.75C6.9875 0.75 7.82813 1.09688 8.52188 1.79063C9.21563 2.48438 9.5625 3.325 9.5625 4.3125V6.1125H10.875C11.1875 6.1125 11.4531 6.22187 11.6719 6.44062C11.8906 6.65937 12 6.925 12 7.2375V15.375C12 15.6875 11.8906 15.9531 11.6719 16.1719C11.4531 16.3906 11.1875 16.5 10.875 16.5H1.125ZM1.125 15.375H10.875V7.2375H1.125V15.375ZM6 12.75C6.4 12.75 6.74063 12.6125 7.02188 12.3375C7.30313 12.0625 7.44375 11.7312 7.44375 11.3438C7.44375 10.9688 7.30313 10.6281 7.02188 10.3219C6.74063 10.0156 6.4 9.8625 6 9.8625C5.6 9.8625 5.25938 10.0156 4.97813 10.3219C4.69688 10.6281 4.55625 10.9688 4.55625 11.3438C4.55625 11.7312 4.69688 12.0625 4.97813 12.3375C5.25938 12.6125 5.6 12.75 6 12.75ZM3.5625 6.1125H8.4375V4.3125C8.4375 3.6375 8.2 3.0625 7.725 2.5875C7.25 2.1125 6.675 1.875 6 1.875C5.325 1.875 4.75 2.1125 4.275 2.5875C3.8 3.0625 3.5625 3.6375 3.5625 4.3125V6.1125ZM1.125 15.375V7.2375V15.375Z'
				fill='#1D2939'
			/>
		</Svg>
	);
}

export default LockedIcon;
